// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../Config.bs.js";
import * as NetworkUtils from "../../../../../library/NetworkUtils.bs.js";
import * as CountryConfig from "../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as PorterStoreProductRepoConfig from "./PorterStoreProductRepoConfig.bs.js";

function fetchProducts(country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/merchandise" + "/admin/products";
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PorterStoreProductRepoConfig.PorterStoreProductListResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchProductDetail(productId, country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/merchandise" + "/admin/products/" + String(productId);
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PorterStoreProductRepoConfig.PorterStoreProductDetailResponseConverter.execute, result);
                            });
                }), requestUrl);
}

var PorterStoreProductRepo = {
  fetchProducts: fetchProducts,
  fetchProductDetail: fetchProductDetail
};

export {
  PorterStoreProductRepo ,
  
}
/* Config Not a pure module */
